export const KILOS_TO_GRAMS_CONVERSION = 1000;

export const POUNDS_TO_KG_CONVERSION = 0.45359237;

export const INCHES_TO_CM_CONVERSION = 2.54;
